class TabelaController extends AbstractController
  @$inject = ['$injector', '$scope', 'pathService', 'tabelaService']

  Alert = null
  Confirm = null

  constructor: ($injector, scope, pathService, @tabelaService) ->
    super($injector)

    Alert = @Alert
    Confirm = @Confirm

    @tabController = scope.tabController

    @loadingTracker = @promiseTracker()

    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/tabelas-sped/"

    @modalTabela = @openPopup("#{@url}tabelas/modal.html", 'tabelaModalController as ctrl')

    @filtro =
      page: 1
      estado: ''

    @pagination =
      page: 1
      perPage: 1
      totalPages: 0

    @loadTabelas()

  loadTabelas: (page = 1)->
    filtro = angular.copy @filtro
    filtro.page = page
    @loadingTracker.addPromise @tabelaService.getList(filtro,(result) =>
      if result.success
        @listOfTabela = result.data.items

        @pagination =
          page: filtro.page
          totalPages: result.data.totalPages
          perPage: 1
      else
        @Alert.error('Ocorreu um erro ao buscar a tabela de códigos.', 'Erro!', false)
    )

  adicionar: ->
    @modalTabela({
      tabela: -> {}
    }, (result) =>
      @loadTabelas() if result.ok
    )

  editar: (tabela) ->
    @modalTabela({
      tabela: -> tabela
    }, (result) =>
      @loadTabelas() if result.ok
    )

  remover: (tabela) ->
    Confirm.warning("Atenção", "Deseja realmente remover a tabela <strong>#{tabela.nome}</strong>? Esta ação <strong>não poderá</strong> ser desfeita.", {
      "Não": null
      "Sim": =>
        @tabelaService.delete(tabela.id, (data) =>
          Alert.success("Tabela <strong>#{tabela.nome}</strong> removida com sucesso.", "Sucesso!")
          @loadTabelas()
        )
    })

  listar: (tabela) ->
    @tabController.addTab
      id: "itens-tabela-#{tabela.id}"
      label: "Itens da tabela #{tabela.nome}"
      data:
        tabela: tabela.id
      closable: true
      url: "#{@url}tabela-itens/index.html"


angular.module("eficienciaFiscalModule").controller("tabelaController", TabelaController)


class TabelaModalController extends AbstractController
  @$inject = ['$injector', 'tabelaService', '$uibModalInstance', 'tabela']

  Alert = null

  constructor: ($injector, @tabelaService, @modalInstance, tabela) ->
    super($injector)

    Alert = @Alert

    @submitTracker = @promiseTracker()

    @tabela = angular.copy tabela


  salvar: (form) ->
    if form.$valid
      callback = (retorno) =>
        Alert.success("Tabela <strong>#{@tabela.nome}</strong> #{if @tabela.id then 'atualizada' else 'criada'} com sucesso.", "Sucesso!")
        @modalInstance.close(new Retorno(true))

      @submitTracker.addPromise(
        if @tabela.id
          @tabelaService.update(@tabela, callback)
        else
          @tabelaService.save(@tabela, callback)
      )

angular.module("eficienciaFiscalModule").controller("tabelaModalController", TabelaModalController)
